const PLAYER_SIZE = {
    XSM: 'xsm',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XLG: 'xlg',
};
const MEDIA_BREAK_POINTS = {
    '1': PLAYER_SIZE.XSM,
    '321': PLAYER_SIZE.SM,
    '500': PLAYER_SIZE.MD,
    '1000': PLAYER_SIZE.LG,
    '1200': PLAYER_SIZE.XLG,
};
function getMediaQuery(width = null) {
    const k = getClosestNumber(Object.keys(MEDIA_BREAK_POINTS), width, true);
    return MEDIA_BREAK_POINTS[k];
}
/**
 *
 * @param arr
 * @param goal
 * @param floor default false, if true return the lowest number
 * @returns
 */
export const getClosestNumber = (arr, goal, floor = false) => {
    return arr.reduce((prev, curr) => {
        const c = parseInt(curr, 10);
        const p = parseInt(prev, 10);
        if (floor) {
            return c <= goal ? c.toString() : p.toString();
        }
        else {
            return c >= goal && p < goal ? c.toString() : p.toString();
        }
    });
};
function getElementLayout(elm) {
    const { clientHeight, clientWidth } = elm;
    if (clientHeight < clientWidth)
        return 'horizontal';
    if (clientHeight === clientWidth)
        return 'square';
    if (clientHeight > clientWidth)
        return 'vertical';
}
export function getElementClasses(elm) {
    const layout = getElementLayout(elm);
    const size = getMediaQuery(elm.clientWidth);
    return [layout, size];
}
export const roundToDecimalPoint = (num, dec = 2) => Number(`${Math.round(Number(`${num}e${dec}`))}e-${dec}`);
